import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
  },

  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },

  button: {
    minWidth: 120,
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
  },
}));
